import React, { useState, useEffect } from "react";
import axios from "axios";
// import { useNavigate } from "react-router-dom";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";

function MultiUserManagement(props) {
  const [editUser, setEditUser] = useState({
    Multi_user_limit: "",
    choose_profile_status: "",
  });
  // const [message, setMessage] = useState("");
  // const navigate = useNavigate();
  const access_token = localStorage.getItem("access_token");
  const [labelDisplay, setLabelDisplay] = useState([]);

  // console.log(access_token)

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  // console.log(headers)

  useEffect(async () => {
    await axios
      .get(`${process.env.REACT_APP_Baseurl}/admin/multi-user-limit/index`, {
        headers: headers,
      })

      .then((response) => {
        //   console.log('api checks', response.data.Multi_User_limit)
        var result = response?.data;
        setEditUser(result);
        // console.log("result", response.data.Multi_user_limit);
      })
      .catch((error) => console.log(error));
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Baseurl}/admin/Label-Management/list-source`,
        {
          headers: headers,
          params: { source: "add-users" },
        }
      );
      setLabelDisplay(response?.data?.label_management || []);
    } catch (error) {
      console.error("Error fetching label display:", error);
    }

  }, []);

  // const handleInput = (e) => {
  //   setEditUser({ ...editUser, [e.target.name]: e.target.value });
  // };

  // const handleInput = (e) => {
  //   const { name, value } = e.target;
  //   setEditUser((prevEditUser) => ({
  //     ...prevEditUser,
  //     [name]: value,
  //   }));

  //   if (e.target.checked === true) {
  //     setEditUser({ ...editUser, [e.target.name]: e.target.value });
  //     setEditUser({ ...editUser, [e.target.id]: 1 });
  //   } else {
  //     setEditUser({ ...editUser, [e.target.name]: e.target.value });
  //     setEditUser({ ...editUser, [e.target.id]: 0 });
  //   }
  // };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setEditUser((prevEditUser) => ({
      ...prevEditUser,
      [name]: value,
    }));

    setEditUser({ ...editUser, [e.target.name]: e.target.value });

    if (e.target.checked === true) {
      setEditUser({ ...editUser, [e.target.name]: e.target.value });
      setEditUser({ ...editUser, [e.target.id]: 1 });
      setEditUser({
        ...editUser,
        [e.target.name]: e.target.value,
        [e.target.name]: 1,
      });
    } else {
      setEditUser({ ...editUser, [e.target.name]: e.target.value });
      setEditUser({ ...editUser, [e.target.id]: 0 });
      setEditUser({ ...editUser, [e.target.name]: e.target.value });
    }
  };

  const handleInputenable = (e) => {
    if (e.target.checked === true) {
      setEditUser({ ...editUser, [e.target.name]: 1 });
    } else {
      setEditUser({ ...editUser, [e.target.name]: 0 });
    }
  };

  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);

  const handleUpdate = async (e) => {
    e.preventDefault();

    const editInputvalue = {
      multiuser_limit: editUser?.Multi_user_limit ? parseInt(editUser.Multi_user_limit, 10) : 0,
      choose_profile_status: editUser && editUser.choose_profile_status !== null && editUser.choose_profile_status !== undefined ? parseInt(editUser.choose_profile_status, 10) : 0,
    };
    // console.log(editInputvalue);

    setProcessing(true);
    setShowOverlay(true);

    let res = await fetch(
      `${process.env.REACT_APP_Baseurl}/admin/multi-user-limit/update`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify(editInputvalue),
      }

    );

    let resjson = await res.json();

    if (resjson.status === true) {
      var resultapi = resjson;

      props?.setApiresponsealert(resultapi);
      props?.setShowalert(true);
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } else {
      if (resultapi === false) {
        var resultError = resultapi;
        props?.setApiresponsealert(resultError);
        props?.setShowalert(true);
        setProcessing(false);
        setShowOverlay(false);
      }
    }
  };

  return (
    <>
      {showOverlay && (<Response_Processing />)}
      <AdminSaveHeader heading={labelDisplay?.[20]?.title} saveText={labelDisplay?.[25]?.title} saveMethod={handleUpdate} />


      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text={labelDisplay?.[21]?.title} />
            <MessageLabel text={labelDisplay?.[22]?.title} />
            <AdminCustomInput type="number" min={0} name="Multi_user_limit" value={editUser?.Multi_user_limit} onChange={handleInput} placeHolder={"Enter multi user limit"} required />
          </Wrapper>
        </LeftWrapper>
        <RightWrapper>
          <Wrapper>
            <MessageHeading text={labelDisplay?.[23]?.title} />
            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={labelDisplay?.[24]?.title} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch name={'choose_profile_status'} checked={editUser?.choose_profile_status == 1} onChange={handleInputenable} />
              </div>
            </div>
          </Wrapper>
        </RightWrapper>
      </FormContainer>

      {/* <div className=" m-0 p-0">
        <div className="">
          <section className="container-fluid">
            <div className="row col-lg-12 ">
              <div className=" col-sm-6 col-md-6 col-lg-6 ">
                <div className="card p-3">
                  <h5>{labelDisplay?.[21]?.title}</h5>
                  <hr></hr>

                  <div className="text-start">
                    <label className="">
                      {labelDisplay?.[22]?.title}
                      {labelDisplay?.[22]?.sub_title}
                    </label>
                    <div className="mt-2">
                      <input
                        type="number"
                        className="rs-input form-control-lg"
                        name="Multi_user_limit"
                        value={editUser?.Multi_user_limit}
                        onChange={handleInput}
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className=" col-sm-6 col-md-6 col-lg-6">
                <div className="card p-3">
                  <h5>{labelDisplay?.[23]?.title}</h5>
                  <hr></hr>

                  <div className="panel panel-primary" data-collapsed="0">
                    <div className="panel-body d-flex justify-content-between">
                      <label className="">{labelDisplay?.[24]?.title}</label>
                      <label className="switch">
                        <input
                          name="choose_profile_status"
                          onChange={handleInputenable}
                          defaultChecked={
                            editUser?.choose_profile_status === 1 ? true : false
                          }
                          checked={
                            editUser?.choose_profile_status === 1 ? true : false
                          }
                          type="checkbox"
                        />
                        <span
                          className="slider round"
                          name="choose_profile_status"
                          onChange={handleInputenable}
                          value={
                            editUser?.choose_profile_status === 1 ? "1" : "0"
                          }
                        ></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div> */}
    </>
  );
}
export default MultiUserManagement;
